import SiteLayout from '@/components/feature/SiteLayout';
import HeroCarousel from './components/HeroCarousel';
import CategoryQuick from './components/CategoryQuick';
import LatestUpdates from './components/LatestUpdates';
import HotRecommend from './components/HotRecommend';
import HomeIntro from './components/HomeIntro';

export default function Home() {
  return (
    <SiteLayout>
      <title>善良的小姨子在线 - 热门电视剧在线观看平台</title>
      <meta
        name="description"
        content="善良的小姨子在线为您提供最新热门电视剧，涵盖剧情介绍与集数更新，方便用户在线观看和追剧，内容丰富，更新及时。"
      />
      <meta
        name="keywords"
        content="善良的小姨子在线,在线电视剧,剧情介绍,电视剧在线观看,追剧平台"
      />
      <HeroCarousel />
      <CategoryQuick />
      <LatestUpdates />
      <HotRecommend />
      <HomeIntro />
    </SiteLayout>
  );
}